import {
  getAuth,
  onAuthStateChanged,
  signInWithRedirect,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { setUser, clearUser } from "../features/user/userSlice";
import { unregisterDevice } from "../features/reservations/services/fcm";

const auth = getAuth();
const provider = new GoogleAuthProvider();

// export const signIn = async (dispatch) => {
//   try {
//     await signInWithRedirect(auth, provider);
//   } catch (error) {
//     console.log(error);
//   }
// };

export const signInWithEmailPassword = async (email, password, dispatch) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    dispatch(setUser({ uid: user.uid, name: user.displayName, email: user.email }));
    return userCredential;
  } catch (error) {
    console.error("Error al iniciar sesión con correo y contraseña:", error);
    // Re-lanzar el error para que el componente lo maneje
    throw error;
  }
};

export const signOutUser = async (dispatch) => {
  try {
    // Limpiar el token push de ESTE dispositivo ANTES de cerrar sesión (después
    // las rules owner-only ya no permiten borrarlo): si no, el próximo que use
    // el celular recibiría las reservas de esta cuenta y el doc quedaría huérfano.
    const uid = auth.currentUser?.uid;
    if (uid) await unregisterDevice(uid);
    await signOut(auth);
    dispatch(clearUser());
  } catch (error) {
    console.log(error);
  }
};

export const initAuthStateListener = (dispatch) => {
  return onAuthStateChanged(auth, (user) => {
    if (user) {
      dispatch(setUser({ uid: user.uid, name: user.displayName }));
    } else {
      dispatch(clearUser());
    }
  });
};

export const getCurrentUser = async () => {
  try {
    const user = await auth.currentUser;
    return user;
  } catch (error) {
    console.error("Error al obtener el usuario actual:", error);
    return null;
  }
};
